import React, { FC, useEffect } from "react";
import { useGetProduct } from "queries/legacy/product-queries";
import { CurrencyCode, getCurrencySymbol } from "@wbly/common";

type SubtotalProviderProps = {
  children: React.ReactNode;
};

export const SubtotalContext = React.createContext({
  initialTotal: 0,
  currentTotal: 0,
  setInitialTotal: (price: number) => {},
  setCurrentTotal: (price: number) => {},
  currentUpsellPrice: 0,
  setCurrentUpsellPrice: (price: number) => {},
  currencyCode: null as string | null,
  currencySymbol: null as string | null,
});

export const SubtotalProvider: FC<SubtotalProviderProps> = ({ children }) => {
  const [initialTotal, setInitialTotal] = React.useState(0);
  const [currentTotal, setCurrentTotal] = React.useState(0);
  const [currentUpsellPrice, setCurrentUpsellPrice] = React.useState(0);
  const [currencyCode, setCurrencyCode] = React.useState<string | null>(null);
  const [currencySymbol, setCurrencySymbol] = React.useState<string | null>(
    null
  );
  const { data: product } = useGetProduct();

  useEffect(() => {
    const subtotalData = localStorage.getItem(`${product?.museSlug}:subtotal`);

    if (product) {
      const { currency } = product.marketplace;

      setCurrencyCode(currencyCode);
      setCurrencySymbol(getCurrencySymbol(currency as CurrencyCode));
    }

    if (subtotalData) {
      const { subtotal } = JSON.parse(subtotalData);

      setInitialTotal(subtotal);
      setCurrentTotal(subtotal);
    }
  }, [product?.museSlug]);

  return (
    <SubtotalContext.Provider
      value={{
        currentTotal,
        setCurrentTotal,
        initialTotal,
        setInitialTotal,
        currentUpsellPrice,
        setCurrentUpsellPrice,
        currencyCode,
        currencySymbol,
      }}
    >
      {children}
    </SubtotalContext.Provider>
  );
};
